<template>
  <SmoothReflow>
    <transition name="fade">
      <div class="error-box-component" :class="variant">
        <img 
          :src="iconSrc" 
          :class="iconClass" 
          :width="iconSize" 
          :height="iconSize" 
          alt="Error" 
        />
        <span class="message-text">{{ message }}</span>
      </div>
    </transition>
  </SmoothReflow>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.error-box-component {
  // Default (original) variant
  background: #fff;
  position: relative;
  font-weight: 600;
  color: $red;
  text-align: center;
  padding: 15px;
  border: 2px solid $red;
  box-shadow: $drop-shadow-light;

  .exclamation {
    background: #fff;
    position: absolute;
    top: 50%;
    left: -13px;
    transform: translateY(-50%);
    border-radius: 50%;
  }

  .message-text {
    display: inline;
  }

  // Inline variant for onboarding pages
  &.inline {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    background: #FF00001A;
    color: #FF0000;
    border: 1px solid #FF0000;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 32px;
    margin-top: 12px;
    text-align: left;
    box-shadow: none;

    .error-icon {
      position: static;
      background: none;
      border-radius: 0;
      transform: none;
      flex-shrink: 0;
    }

    .message-text {
      flex: 1;
    }
  }
}
</style>

<script>
export default {
  name: "ErrorBox",
  props: {
    message: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: "default",
      validator: value => ["default", "inline"].includes(value)
    }
  },
  computed: {
    iconSrc() {
      return this.variant === "inline" 
        ? require("@/assets/images/warning.svg")
        : require("@/assets/images/alert.svg");
    },
    iconClass() {
      return this.variant === "inline" ? "error-icon" : "exclamation";
    },
    iconSize() {
      return this.variant === "inline" ? "24" : "26";
    }
  }
};
</script>